<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div actions>The Scroller's buffer has {{ itemsCount() }} items.</div>
  <div description>
    <p>
      We may use <em>Adapter.itemsCount</em> read-only property to see how many
      items exist in the Scroller's Buffer at the moment. The
      <em>itemsCount</em> value is the same as the value of DOM elements
      counter. In this demo we show it via a signal counter.
    </p>
  </div>
</app-demo>
